/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Reply_SubmitInputs */

const en_admin_tickets_reply_submit = /** @type {(inputs: Admin_Tickets_Reply_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send Reply`)
};

const zh_admin_tickets_reply_submit = /** @type {(inputs: Admin_Tickets_Reply_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送回复`)
};

/**
* | output |
* | --- |
* | "Send Reply" |
*
* @param {Admin_Tickets_Reply_SubmitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_reply_submit = /** @type {((inputs?: Admin_Tickets_Reply_SubmitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Reply_SubmitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_reply_submit(inputs)
	return zh_admin_tickets_reply_submit(inputs)
});
export { admin_tickets_reply_submit as "admin.tickets.reply_submit" }